// 处理成立时间
export const getEstiblishTimeByVal = function (obj: any, val: string) {
  // const arr = estiblishTime.arr1;
  // const obj = arr[val];

  // 获取指定年的时间戳
  const getTimestamp = (num: number) => {
    const yearMS = 31536000000;
    return num ? Date.now() - yearMS * num : Date.now();
  };
  // 获取指定年的时间戳-毫秒
  // const getTimestampV1 = (time: any, suf: any) => {
  //   return time ? new Date(`${time} ${suf}`).getTime() : Date.now();
  // };
  // // 字符串转换成时间字符串
  // const getReplaceTimeStr = (time: string) => {
  //   return time.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
  // };
  // 时间毫秒转换成年-月-日
  const getDateFormat = (time: string) => {
    const date = new Date(parseInt(time));
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  // console.log('******************************');
  // console.log('obj', obj);
  // console.log('val', val);
  // console.log('*************** egg-tyc log ***************');

  if (obj) {
    // const time = new Date();
    // const year = time.getFullYear();
    // const month = time.getMonth();
    // const day = time.getDate();
    // const startyear = Number(year) - Number(obj.end);
    // const endyear = Number(year) - Number(obj.start);
    // const newTimeStart = new Date();
    // newTimeStart;
    // const myStart = new Date();
    // myStart.setFullYear(startyear, month, day);
    // const myEnd = new Date();
    // myEnd.setFullYear(endyear, month, day);
    // const result = {
    //   title: obj.title,
    //   start: myStart.getTime(),
    //   end: myEnd.getTime(),
    // };
    const result: any = {
      title: obj.title,
      start: getTimestamp(obj.end),
      end: getTimestamp(obj.start),
    };
    result.val = obj.val;
    result.title = obj.title;
    return result;
  } else if (val.indexOf('.') === 0) {
    const times = val.split('.');
    if (times.length === 3) {
      if (times[1] && times[2] && times[1].length > 3 && times[2].length > 3) {
        // 20210704版本，成日时间引入日期组件，入参由".15.20" 改为 字符串型".1625328000000.1625328000000"
        const t1 = getDateFormat(times[1]);
        const t2 = getDateFormat(times[2]);
        let title = `${t1}～${t2}`;
        if (t1 == t2) {
          title = `${t1}`;
        }
        return {
          title: `${title}`,
          start: `${times[1]}`,
          end: `${times[2]}`,
          val,
        };
      } else {
        return {
          // 1001 是个超过范围的时间值。用这个值判断是否该值是没有输入
          title: times[2] == '1001' ? `成立${times[1]}年以上` : `成立${times[1]}～${times[2]}年`,
          start: times[2] == '1001' ? -1 : getTimestamp(Number(times[2])),
          end: getTimestamp(Number(times[1])),
          val,
        };
      }
    }
  }
  return obj;
};
